// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"818aabca","453":"c686c805"}[chunkId] + ".chunk.js";
};